


































import { Component, Vue } from 'vue-property-decorator'
import { UserStore, userInfoTypes } from '@/store/modules/User'
import { BaseStore } from '@/store/modules/Base'

@Component({
  name: 'Introduction'
})
export default class Introduction extends Vue {
  // // 获取我的信息
  // get userInfo (): userInfoTypes {
  //   return UserStore.userInfo
  // }

  // // 获取商户信息 -- 非自己的信息
  // get clientInfo (): userInfoTypes {
  //   return BaseStore.clientInfo
  // }

  // 如果有 商户信息就要显示商户信息 -- 非自己的信息
  get info (): userInfoTypes {
    if (BaseStore.clientInfo.parentMchId) {
      return BaseStore.clientInfo
    }
    return UserStore.userInfo
  }
}
